"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Module_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Module"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let ModuleChoice = class ModuleChoice extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.modules = [];
        this.checked = false;
        this.loading = false;
        this.shown = true;
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.eventTracker = new EventTracker_1.default();
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    toggleCheck(v) {
        this.checked = v;
    }
    get plainModules() {
        const pModules = [
            new Module_1.default({
                "name": "Proposals",
                "slug": "proposals",
                "url": "",
                "tags": {},
                "description": "Description"
            }),
            new Module_1.default({
                "name": "Tracking",
                "slug": "tracking",
                "url": "",
                "tags": "",
                "description": "Description"
            }),
            new Module_1.default({
                "name": "Results",
                "slug": "results",
                "url": "",
                "tags": "",
                "description": "Description"
            })
        ];
        pModules.forEach((m, i) => {
            const actMIx = this.modules.findIndex((am) => am.slug === m.slug);
            if (actMIx !== -1) {
                const modName = pModules[i].name;
                pModules[i] = this.modules[actMIx];
                pModules[i].name = modName;
            }
        });
        return pModules;
    }
    /*************
     * OLD CODE FOR FETCHING MODULES FROM AN EXTERNAL ENDPOINT
     *
        fetchedActiveModules: Module[] = []

        async fetchModules() {
            const baseURL = 'http://localhost:8000'

            const config = {
                baseURL,
                timeout: 30000,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                }
            }

            axios.create(config);

            this.loading = true

            let modules: Module[] = [{
                'name': '',
                'description': '',
                'slug': '',
                'url': ''
            }];

            try {
                const url = '/modules';
                const response = await axios.get(config.baseURL + url);

                modules = response.data;
                this.fetchedActiveModules = modules;

            } catch(e:any) {
                console.log(e.message);
            }

            this.loading = false;
        }

    **************/
    logout() {
        window.location.href = '/logout';
    }
    trackInMixpanel(m, a) {
        const originModule = localStorage.getItem('currentModule');
        const destinationModule = m;
        this.mixpanelHandler.trackEvent('switchToModule', {
            'origin': 'Selector',
            'from': originModule,
            'to': destinationModule,
            'hadAccess': a
        });
    }
    switchModule(m) {
        // set showModuleChoice
        const showModule = !this.checked;
        const disableChoiceModules = ['proposals'];
        if (disableChoiceModules.includes(m)) {
            localStorage.setItem('showModuleChoice', 'true');
        }
        else {
            localStorage.setItem('showModuleChoice', showModule.toString());
        }
        const destinationModule = this.modules.find((mod) => mod.slug === m);
        if (destinationModule) {
            const destMod = new Module_1.default(destinationModule);
            this.trackInMixpanel(m, true);
            destMod.switchToThisModule();
        }
        else {
            this.trackInMixpanel(m, false);
        }
    }
    mounted() {
        this.eventTrackerListener('Login', {
            userId: this.raw_user.id,
            clientId: this.raw_user.id_cliente,
            lastLogin: this.raw_user.last_login_at,
            initialLogin: this.raw_user.created_at,
            currentCropId: this.raw_user.current_crop_id
        });
        let isModuleChoiceShown = true;
        const localModuleChoice = localStorage.getItem('showModuleChoice');
        const lastModuleVisited = localStorage.getItem('currentModule');
        if (localModuleChoice) {
            isModuleChoiceShown = (localModuleChoice === 'true');
        }
        const exceptions = ['proposals'];
        if (exceptions.includes(lastModuleVisited)) {
            isModuleChoiceShown = true;
        }
        this.shown = (isModuleChoiceShown === true);
        if (!this.shown) {
            const lastModule = this.modules.find((m) => m.slug === lastModuleVisited);
            // Last module is among those accesibles -> redirect to it
            if (lastModule) {
                const lastModuleObj = new Module_1.default(lastModule);
                lastModuleObj.switchToThisModule();
            }
            else {
                // Last module is no longer accessible -> redirect to results
                const lastModuleObj = new Module_1.default('results');
                lastModuleObj.switchToThisModule();
            }
        }
        const moduleAccessibleSlugs = this.modules.reduce((accumulator, mod) => {
            return accumulator += mod.slug + ' ';
        }, '');
        localStorage.setItem('modulesAvailable', moduleAccessibleSlugs);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ModuleChoice.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ModuleChoice.prototype, "modules", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ModuleChoice.prototype, "is_bmk", void 0);
ModuleChoice = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            FullsizeTemplate: bmk_ui_framework_1.FullsizeTemplate,
            ModuleCardGrid: bmk_ui_framework_1.ModuleCardGrid,
            CheckBox: bmk_ui_framework_1.CheckBox,
            PageHeading: bmk_ui_framework_1.PageHeading,
            Loading: bmk_ui_framework_1.Loading,
            LogoutIcon: bmk_ui_framework_1.LogoutIcon
        }
    })
], ModuleChoice);
exports.default = ModuleChoice;
